import React from 'react';
import image from '../../images/verticalstorage.png';
import image1 from '../../images/vs1.png';
import image2 from '../../images/vs2.png';
import image3 from '../../images/vs3.png';
import image4 from '../../images/vs4.png';

const Container = (props) => {
  const {isMobile} = props;

  return (
    isMobile ?
      <div style={styles.containerStyle1}> 
        <img src={image1} alt="product_img" width='98%' height='auto' />
        <div style={styles.col2MobileStyle}>
          <div style={{ width: '50%' }}>
            <img src={image} alt="product_img" width='90%' height='auto' />
            <img src={image2} alt="product_img" width='70%' height='auto' />
          </div>
          <div style={{ width: '50%' }}>
            <img src={image3} alt="product_img" width='100%' height='auto' />
            <img src={image4} alt="product_img" width='100%' height='auto' />
          </div>
        </div>
      </div> :
      
      <div style={styles.containerStyle1}> 
        <div style={styles.containerStyle2}>
          <div style={styles.col1Style}>
            <img src={image1} alt="product_img" width='70%' height='auto' />
          </div>
          <div style={styles.col2Style}>
            <div style={{ width: '50%' }}>
              <img src={image} alt="product_img" width='90%' height='auto' />
              <img src={image2} alt="product_img" width='70%' height='auto' />
            </div>
            <div style={{ width: '50%' }}>
              <img src={image3} alt="product_img" width='100%' height='auto' />
              <img src={image4} alt="product_img" width='100%' height='auto' />
            </div>
          </div>
        </div>
      </div>
  )
};

export default Container;

const styles = {
  containerStyle1: {
    width: '100%',
    height: '100%'
  },
  containerStyle2: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  col1Style: {
    width: '50%',
    height: '100%',
    paddingRight: '5%',
    paddingLeft: '5%',
  },
  col2Style: {
    width: '50%',
    height: '100%',
    display: 'flex',
    flexDirection :'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start'
  },
  textStyle: {
    fontSize: '1.8vmin'
  },
  containerMobileStyle1: {
    width: '100%',
    height: 'auto',
    marginBottom: '10vmin'
  },
  textMobileStyle: {
    fontSize: '4.5vmin',
    color: 'rgba(0,0,0,0.8)'
  },
  col2MobileStyle: {
    width: '95%',
    height: 'auto',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingRight: '5%'
  },
};